// Create a new object, that prototypically inherits from the Error constructor
export function AttachmentError(message?) {
  this.name = 'AttachmentError';
  this.message = message || 'Problem with Email attachments';
  this.stack = (new Error()).stack;
}
AttachmentError.prototype = Object.create(Error.prototype);
AttachmentError.prototype.constructor = AttachmentError;
